import { Injectable } from '@angular/core';

import { EntityStore, StoreConfig } from '@datorama/akita';

import { RepliesState } from './replies.state';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'replies', resettable: true, idKey: 'id' })
export class RepliesStore extends EntityStore<RepliesState> {
  constructor() {
    super();
  }
}
